import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-name"]
const _hoisted_2 = { class: "pf_label" }
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "pf_input" }
const _hoisted_5 = ["id", "disabled"]
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "pf_image"
}
const _hoisted_8 = ["src", "alt"]

import { PropType, ref, watch } from 'vue'
    import { Term } from '@/types/product';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSelect',
  props: {
        id: { type: [String, Number], required: false },
        name: { type: String, required: true },
        label: { type: String, required: true },
        terms: { type: Array as PropType<Term[]>, required: true },
        useImage: { type: Boolean, required: false, default: false },
        modelValue: { type: Object as PropType<Term | null>, required: false },
        disableForm: { type: Boolean, required: false, default: false }
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props

    

    const selectedValue = ref<String>('')

    

    watch(selectedValue, (current, old) => {
        if(parseInt(current as string) !== props.modelValue?.id) {
            const activeTerm = props.terms.find(o => o.id === parseInt(current as string))
            emits("update:modelValue", activeTerm)
        }
    })

    watch(() => props.modelValue, (current, old) => {
        if(current?.id !== parseInt(selectedValue.value as string)) {
            selectedValue.value = current?.id.toString() as string
        }
    }, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pf_container", ['pf_'+props.name]]),
    "data-name": props.name,
    "data-type": "select"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        for: 'pf_' + props.name
      }, _toDisplayString(props.label), 9, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("select", {
        id: 'pf_' + props.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event)),
        disabled: props.disableForm
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.terms, (term) => {
          return (_openBlock(), _createElementBlock("option", {
            value: term.id,
            key: term.id
          }, _toDisplayString(term.name), 9, _hoisted_6))
        }), 128))
      ], 8, _hoisted_5), [
        [_vModelSelect, selectedValue.value]
      ]),
      (props.useImage && props.modelValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("img", {
              src: props.modelValue.image,
              alt: props.modelValue.name
            }, null, 8, _hoisted_8)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}
}

})